<template>
  <!-- IntegrationsCustomFields.vue -->
  <div>
    <LoadingSpinner v-if="Object.keys(customFieldsOptions).length === 0" />
    <section class="account" v-else>
      <div class="contenedor">
        <div class="card mt-3">
          <div class="body p-4 email-account">
            <div class="col-sm-12 pb-3">
              <h5 class="bold mb-4">
                {{ $t("lang.integrations.title") }}
              </h5>

              <vue-form-generator
                ref="crmForm"
                :schema="crmSchema"
                :model="crmConfig"
                :options="formOptions"
              >
              </vue-form-generator>

              <h6 class="bold mt-4 mb-4">
                {{ $t("lang.integrations.configcustomfields") }}
              </h6>

              <div class="table-responsive table-transactions pt-4">
                <table class="table">
                  <thead class>
                    <tr>
                      <th>Entity type</th>
                      <th>Oliver's value</th>
                      <th>Pipedrive's field</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(option, index) in customFields" :key="index">
                      <td>{{ option.type }}</td>
                      <td>{{ option.label }}</td>
                      <td>
                        <select
                          class="form-control"
                          v-model="customFieldsValues[option.id]"
                          v-if="option.default_value == null"
                        >
                          <option
                            key="-1"
                            :value="getFullKey(option.type, null)"
                          >
                            {{ $t("lang.label.choose") }}
                          </option>
                          <option
                            v-for="(option2, index2) in customFieldsOptions[
                              option.type
                            ]"
                            :key="index2"
                            :value="getFullKey(option.type, option2.key)"
                            :disabled="
                              isOptionDisabled(
                                option.id,
                                getFullKey(option.type, option2.key),
                                option2
                              )
                            "
                          >
                            {{ option2.name }} ({{ option2.fieldType }})
                          </option>
                        </select>
                        <div>{{ option.default_value }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="text-right">
                  <button
                    class="btn btn-sm btn-primary mr-2"
                    @click="hideCustomFields"
                  >
                    {{ $t("lang.button.back") }}
                  </button>
                  <button
                    class="btn btn-sm btn-primary"
                    @click="setCustomFields"
                  >
                    {{ $t("lang.button.save") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tutorial from "@/components/Tutorial.vue";
import { crmService } from "@/_services";
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";

export default {
  props: {
    crmConfig: Object,
  },
  data() {
    return {
      customFields: {},
      customFieldsOptions: {},
      customFieldsValues: [],
      crmSchema: {
        fields: [
          {
            type: "checklist",
            label: this.$t("lang.integrations.syncoptions"),
            model: "sync_options",
            listBox: true,
            featured: true,
            checklistOptions: {
              value: "id",
              name: "label",
            },
            values: [
              {
                id: "auto_sync_active_contacts",
                label: this.$t("lang.integrations.auto_sync_active_contacts"),
              },
            ],
          },
        ],
      },
      defaulOption: false,
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
    };
  },

  components: {
    Header,
    LoadingSpinner,
    Tutorial,
    "vue-form-generator": VueFormGenerator.component,
  },

  computed: {
    ...mapState({
      headerTab: (state) => state.header.tab,
    }),

    user() {
      return this.$store.state.authentication.user;
    },
  },

  created() {
    this.getCrmSettings();
  },

  methods: {
    getFullKey(type, key) {
      return type + "---" + key;
    },
    isOptionDisabled(index, key, option2) {
      if (this.user.role_id == 1) {
        if (
          ![
            "text",
            "phonenumber",
            "number",
            "varchar",
            "int",
            "select",
            "booleancheckbox",
            "checkbox",
            "date",
            "textarea",
            "html",
          ].includes(option2.fieldType)
        ) {
          return true;
        }
      } else {
        if (
          ![
            "text",
            "phonenumber",
            "number",
            "varchar",
            "int",
            "textarea",
            "date"
          ].includes(option2.fieldType)
        ) {
          return true;
        }
      }
      if (this.customFieldsValues[index] === key) {
        return false;
      } else {
        return this.customFieldsValues.includes(key);
      }
    },
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    getCrmSettings() {
      crmService
        .getCustomFields()
        .then((result) => {
          if (result) {
            this.customFields = result;
            this.customFields.forEach((item, key) => {
              this.customFieldsValues[item.id] = this.getFullKey(
                item.type,
                item.crm_custom_field_key
              );
            });
            crmService
              .getCustomFieldsValues()
              .then((result) => {
                if (result) {
                  this.customFieldsOptions = result;
                  this.customFieldsOptions[-1] = "";
                }
              })
              .then((error) => {});
          }
        })
        .then((error) => {});
    },
    setCustomFields() {
      crmService
        .setCustomFields(this.customFieldsValues, this.crmConfig)
        .then((result) => {
          if (result) {
            this.$swal({
              type: "success",
              text: this.$t("lang.label.great"),
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: this.$t("lang.button.ok"),
              cancelButtonColor: "#d33a2c",
            });
          }
        })
        .then((error) => {
          this.loading = false;
        });
    },
    hideCustomFields() {
      this.$emit("hideCustomFields");
    },
  },
};
</script>